export const PROJECTS_PAGE_SEO_DESC =
  "Projects by Raj Rajhans. Raj Rajhans is a Product Engineer @ invideo. This blog reflects Raj's ideas, projects and learnings.";

export const ABOUT_PAGE_SEO_DESC =
  "About Raj Rajhans. Raj Rajhans is Product Engineer @ invideo. This blog reflects Raj's ideas, projects and learnings.";

export const PROFILE_IMAGE_URL = (id) =>
  `https://assets.rajrajhans.com/blog/profile-photos-v2/${id}.jpg`;
